import React from "react";

function Amenities({ formData, handleChange }) {
  return (
    <fieldset className="border border-gray-300 p-4 rounded-md">
      <legend className="text-lg font-semibold px-2">Amenities</legend>
      <div className="grid grid-cols-2 gap-4">
        {Object.keys(formData.amenities).map((amenity) => (
          <label key={amenity} className="flex items-center space-x-2">
            <input
              type="checkbox"
              name={amenity}
              checked={formData.amenities[amenity]}
              onChange={handleChange}
              className="h-4 w-4 text-blue-600 border-gray-300 rounded"
            />
            <span className="text-gray-700 capitalize">{amenity.replace(/([A-Z])/g, " $1")}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}

export default Amenities;
